import React from "react";
import IconButton from "../../../base/button/icon_button";
import {SvgIcon} from "@mui/material";
import {ReactComponent as DuplicateIcon} from "../../../../../assets/images/notifications/duplicate.svg";
import {Col} from "reactstrap";
import {ReactComponent as TimeIcon} from "../../../../../assets/images/notifications/time.svg";
import DateUtils from "../../../../../core/services/date-utils";
import useAccessLevels from "../../../../hooks/use-access-levels";
import ProductInformationPopover from "../../draggable-popover/product-information-popover";

const SentNotificationCard = ({notification, onDuplicate}) => {
    const data = notification?.data ? JSON.parse(notification.data) : {}
    const operatorAccessLevels = useAccessLevels();

    return (
        <>
            <div className={'sent-notification-card'}>
                <div className={'d-flex align-items-center'}>
                    <p className={'title'}>
                        {notification?.title ?? ''}
                    </p>
                    {
                        operatorAccessLevels.packages.notifications.manageCustomerNotifications &&
                        <IconButton onPressed={onDuplicate} color={'secondary'}>
                            <SvgIcon component={DuplicateIcon} className={'icon normal'}/>
                        </IconButton>
                    }
                </div>
                <div className={'mt-2'}>
                    <p className={'bold'}>
                        Operator:
                        <span>
                            {notification?.senderOperator?.firstName ?? ''} {notification?.senderOperator?.lsatName ?? ''}
                        </span>
                    </p>
                </div>
                <div>
                    {
                        !!data?.PartNo &&
                        <p className={'bold part-number-fluid'}>
                            Part Number:
                            <ProductInformationPopover
                                partNo={data?.PartNo}
                                wrapperProps={{
                                    className: 'value part-number-fluid d-inline-block'
                                }}
                            >
                                {data?.PartNo ?? ""}
                            </ProductInformationPopover>
                        </p>
                    }
                    {
                        !data?.PartNo &&
                        <p className={'bold part-number-fluid'}>
                            {
                                data?.Category
                                    ? "Category:"
                                    : data?.Url
                                        ? "Url:"
                                        : data?.Keyword
                                            ? "Keyword:"
                                            : "Data Unknown"
                            }
                            <span className={'value part-number-fluid'}>
                               {
                                   data?.Category
                                       ? data.Category.Title
                                       : data?.Url
                                           ? data.Url
                                           : data?.Keyword
                                               ? data.Keyword
                                               : ""
                               }
                            </span>
                        </p>
                    }
                </div>
                <div className={'d-flex align-items-center justify-content-between'}>
                    <Col xs={'auto'} className={'p-0'}>
                        <p className={'bold'}>
                            Users:
                            <span className={'value'}>
                                {notification?.numberOfReceivers}
                        </span>
                        </p>
                    </Col>
                    <Col xs className={'text-right p-0'}>
                        <p className={'date'}>
                            <TimeIcon className={'mx-1'}/>
                            {
                                notification?.submitDateTime
                                    ? DateUtils.serverToLocal(notification.submitDateTime).format(DateUtils.dateTimeFormat)
                                    : ''
                            }
                        </p>
                    </Col>
                </div>
                <div className={'text-break text-wrap'}>
                    <p className={'description'}>
                        {notification?.body ?? ''}
                    </p>
                </div>
            </div>

        </>
    );
}


export default SentNotificationCard;
